import { useGetMySignedDocuments } from '@apiServices'
import { Card, CardTitle, LoadingIndicator } from '@components'
import { EventUserDocumentVersion } from 'tokensoft-shared-types'

const ipfsGateway = import.meta.env.VITE_IPFS_GATEWAY

const resolveUri = (uri?: string | null) => {
  if (!uri) return '#'
  if (uri.startsWith('ipfs://')) {
    const cid = uri.replace('ipfs://', '')
    return `${ipfsGateway}/${cid}`
  }
  return uri
}

export const MySignedDocuments = () => {
  const { data: documents, isLoading, error } = useGetMySignedDocuments()

  return (
    <Card
      className={`no-padding ${!isLoading && error === null && documents?.length === 0 ? 'hidden' : ''}`}
      id='signed-documents-card'
    >
      <CardTitle className='card-header'>Signed Documents</CardTitle>
      {isLoading ? (
        <div className='mb-12'>
          <LoadingIndicator />
        </div>
      ) : error ? (
        <div className='p-4 text-red-500'>
          An error occurred while fetching your signed documents.
        </div>
      ) : documents && documents.length > 0 ? (
        <div className='px-4 pb-6'>
          <ul>
            {documents.map((doc: EventUserDocumentVersion) => {
              const resolvedUrl = resolveUri(doc.uri)
              const fileName = `signed-document-${doc.id}.pdf`

              return (
                <li key={doc.id} className='px-4 py-2'>
                  <a
                    href={resolvedUrl}
                    download={fileName}
                    className='text-blue-500 underline'
                  >
                    {doc.eventName}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      ) : (
        <div className='p-4'>You have no signed documents.</div>
      )}
    </Card>
  )
}
